var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    [
      _c("template", { slot: "header" }, [_vm._v("剪贴板访问")]),
      _c(
        "el-row",
        { attrs: { gutter: 10 } },
        [
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "div",
                { staticClass: "d2-mb" },
                [
                  _c("el-input", {
                    staticStyle: { width: "200px" },
                    model: {
                      value: _vm.text,
                      callback: function($$v) {
                        _vm.text = $$v
                      },
                      expression: "text"
                    }
                  }),
                  _c(
                    "el-button",
                    {
                      staticClass: "d2-ml",
                      on: {
                        click: function($event) {
                          return _vm.copyText()
                        }
                      }
                    },
                    [_vm._v("将左侧输入框内的文字复制进剪贴板")]
                  )
                ],
                1
              ),
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      return _vm.copyHtml()
                    }
                  }
                },
                [
                  _vm._v("将 "),
                  _c("span", { domProps: { innerHTML: _vm._s(_vm.html) } }),
                  _vm._v(" 连带样式一起复制进剪贴板，然后去 Word 文档内粘贴")
                ]
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c("el-alert", {
                staticClass: "d2-mb",
                attrs: {
                  title:
                    "在 IE 浏览器或者高版本 Chrome 下你才可以通过下面这两个按钮获取剪贴板数据",
                  type: "warning",
                  "show-icon": ""
                }
              }),
              _c(
                "div",
                { staticClass: "d2-mb" },
                [
                  _c(
                    "el-tooltip",
                    { attrs: { content: "需要 IE 浏览器", placement: "top" } },
                    [
                      _c("el-button", { on: { click: _vm.readText } }, [
                        _vm._v("readText( )")
                      ])
                    ],
                    1
                  ),
                  _c(
                    "el-tooltip",
                    { attrs: { content: "需要 IE 浏览器", placement: "top" } },
                    [
                      _c("el-button", { on: { click: _vm.read } }, [
                        _vm._v("read( )")
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _c("el-input", {
                attrs: {
                  type: "textarea",
                  placeholder: "在这里检验你的剪贴板 ( text/plain 数据 )"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }